<mat-grid-list cols="4">
  <mat-grid-tile *ngFor="let tile of tiles" [colspan]="tile.cols" [rowspan]="tile.rows" [style.background]="tile.color">
    {{tile.text}}
  </mat-grid-tile>
</mat-grid-list>